import React from 'react';
import { AuthBrandHeader } from './AuthBrandHeader';

export function AuthPageShell({ children }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-bg px-4 py-12">
      <div className="w-full max-w-md">
        <AuthBrandHeader />
        {children}
      </div>
    </div>
  );
}
